import { useState, type ReactNode } from 'react';

import { Campo, Painel } from '../../comum';
import type { PropsSecao } from './comum';

/**
 * Frequência e escopo do espelhamento do inventário.
 */
export function SecaoSincronizacao({ c, podeEditar, acao, salvar }: PropsSecao): ReactNode {
  const [sync, setSync] = useState(c.sync);

  return (
    <Painel titulo="Sincronização">
      <label style={{ display: 'flex', gap: 8 }}>
        <input
          type="checkbox"
          checked={sync.automatico}
          disabled={!podeEditar}
          onChange={(e) => setSync({ ...sync, automatico: e.target.checked })}
        />
        <span>Sincronizar automaticamente</span>
      </label>
      <div className="grade2">
        <Campo
          rotulo="Intervalo (minutos)"
          ajuda="Mínimo de 5. Abaixo disso um sync não termina antes do próximo começar."
        >
          <input
            type="number"
            min={5}
            value={sync.intervaloMin}
            disabled={!podeEditar}
            onChange={(e) => setSync({ ...sync, intervaloMin: Number(e.target.value) })}
          />
        </Campo>
        <Campo
          rotulo="Timelines por execução"
          ajuda="Quantos históricos de chamado buscar por sync. É o que alimenta a base de conhecimento da IA, aos poucos."
        >
          <input
            type="number"
            min={0}
            value={sync.timelinePorSync}
            disabled={!podeEditar}
            onChange={(e) => setSync({ ...sync, timelinePorSync: Number(e.target.value) })}
          />
        </Campo>
      </div>
      <button
        className="primario"
        disabled={acao.executando || !podeEditar}
        onClick={() => salvar('sync', sync, 'Sincronização')}
      >
        Salvar
      </button>
    </Painel>
  );
}
